import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-button-with-spinner',
  templateUrl: './button-with-spinner.component.html',
  styleUrls: ['./button-with-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonWithSpinnerComponent {
  @Input() label: string = '';
  @Input() isBusy: boolean = false;
  @Input() data: any;
  @Output() onClick = new EventEmitter<any>();
  @Input() isBusyLabel: string = '';
  handleClick() {
    this.onClick.emit(this.data);
  }
}
